import { SplitModuleFields, SplitModuleProps } from '../types/SplitModule.types'
import { ComponentParamsGeneral, StringField, VideoSitecoreField } from '../../../types/types'
import { SplitModuleMock } from '../../../mocks/SplitModule.mock'
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-react/types/components/Link'
import {
  ImageField,
} from '@sitecore-jss/sitecore-jss-react/types/components/Image'

export class SplitModuleModel {
  private readonly fields?: SplitModuleFields
  private readonly params?: ComponentParamsGeneral

  constructor(props: SplitModuleProps) {
    this.fields = props.fields
    this.params = props.params
  }

  get AlignToTextModule(): StringField {
    return this.fields?.AlignToTextModule ?? { value: '' }
  }

  get bodyText(): StringField {
    return this.fields?.bodyText ?? SplitModuleMock?.fields?.bodyText
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow
  }

  get title(): StringField {
    return this.fields?.title ?? SplitModuleMock?.fields?.title
  }

  get link1(): LinkFieldValue {
    return this.fields?.link1?.value ?? SplitModuleMock?.fields?.link1?.value
  }

  get link2(): LinkFieldValue {
    return this.fields?.link2?.value ?? SplitModuleMock?.fields?.link2?.value
  }

  get image(): ImageField {
    return this.fields?.image ?? SplitModuleMock?.fields?.image
  }

  get videoHeading(): StringField {
    return this.fields?.videoHeading ?? SplitModuleMock?.fields?.videoHeading
  }

  get videoSubHeading(): StringField {
    return this.fields?.videoSubHeading ?? SplitModuleMock?.fields?.bodyText
  }

  get imageMobile(): ImageField {
    return this.fields?.ImageMobile ?? SplitModuleMock?.fields?.imageMobile
  }

  get video(): VideoSitecoreField {
    return this.fields?.video ?? SplitModuleMock?.fields?.video
  }

  get useVideo(): boolean {
    return (
      this.fields?.useVideo?.value ?? SplitModuleMock?.fields?.useVideo?.value
    )
  }

  get AllowFallbackForMobile(): boolean {
    return !!this.fields?.AllowFallbackForMobile?.value
  }

  get imagePosition(): 'left' | 'right' {
    return this.params?.imagePosition ?? SplitModuleMock?.params?.imagePosition
  }

  get variant(): StringField | undefined {
    return this.fields?.Variant
  }

  get videoid(): StringField | undefined {
    return this.fields?.videoid
  }
}
